import { FC } from 'react'
import logo from '../nordconcept_logo.png'

export const NordconceptHeaderLogo: FC = () => (
  <img className="logo" src={logo} alt="Nordconcept" width="90" height="36" />
)

export const NordconceptHeaderLogoMobile: FC = () => (
  <img className="logo" src={logo} alt="Nordconcept" width="70" height="28" />
)
